import {
  AssetsDeployedSection,
  ListItem,
  MarketCapitalizationSection,
  ReturnSection,
  Section,
  TotalRewardsSection,
} from '@/components';
import APP_CONFIG from '@/config/app';
import { REWARDS } from '@/utils/strings';
import { FC, useMemo } from 'react';
const { MAIN_GAP } = APP_CONFIG.STYLES;
const visualizeElementsAndSpacing = false;
interface RewardsSummarySectionProps {
  formattedTotalRewardsValueInUsd: string;
  blendedReturn: number;
  blendedMarketCap: number;
  showCondensedInformation?: boolean;
  showMarketCapitalization?: boolean;
  showHeader?: boolean;
  isFullBleed?: boolean;
  isBackgroundTransparent?: boolean;
}
const RewardsSummarySection: FC<RewardsSummarySectionProps> = ({
  formattedTotalRewardsValueInUsd,
  blendedReturn,
  blendedMarketCap,
  showCondensedInformation = false,
  showMarketCapitalization = false,
  showHeader = true,
  isFullBleed = false,
  isBackgroundTransparent = false,
}) => {
  const borderClass = visualizeElementsAndSpacing ? 'border-white border' : '';
  const spacingClass = `gap${MAIN_GAP}`;
  const headerContent = useMemo(
    () => (
      <ListItem
        isHeader
        mainText={REWARDS.HEADER}
        subText={REWARDS.SUB_HEADER}
        className={borderClass}
      />
    ),
    [formattedTotalRewardsValueInUsd, borderClass],
  );
  const sections = useMemo(
    () => [
      {
        Component: AssetsDeployedSection,
        props: { label: REWARDS.DEPLOYED_ASSETS_LABEL, returnRate: null },
      },
      {
        Component: ReturnSection,
        props: {
          returnRate: blendedReturn,
          label: REWARDS.EFFECTIVE_RETURN_LABEL,
        },
      },
      {
        Component: TotalRewardsSection,
        props: { label: REWARDS.REWARDS_EARNED_LABEL, returnRate: null },
      },
      ...(showMarketCapitalization || !showCondensedInformation
        ? [
            {
              Component: MarketCapitalizationSection,
              props: {
                marketCap: blendedMarketCap,
                label: REWARDS.EFFECTIVE_MARKET_CAPITALIZATION_LABEL,
                returnRate: null,
              },
            },
          ]
        : []),
    ],
    [
      blendedReturn,
      blendedMarketCap,
      showCondensedInformation,
      showMarketCapitalization,
    ],
  );
  if (showCondensedInformation) {
    return (
      <Section
        {...(showHeader && {
          headerTitle: REWARDS.HEADER,
          subHeader: REWARDS.SUB_HEADER,
        })}
        body={
          <div className={`flex flex-row ${spacingClass} ${borderClass}`}>
            {sections.map(({ Component, props }, index) => (
              <Component key={index} {...props} />
            ))}
          </div>
        }
        isFullBleed={isFullBleed}
        isBackgroundTransparent={isBackgroundTransparent}
      />
    );
  }
  return (
    <Section
      {...(showHeader && { headerTitle: headerContent })}
      body={
        <div className={`flex flex-row ${spacingClass} ${borderClass}`}>
          {sections.map(({ Component, props }, index) => (
            <Component key={index} {...props} />
          ))}
        </div>
      }
      className={borderClass}
      isFullBleed={isFullBleed}
      isBackgroundTransparent={isBackgroundTransparent}
    />
  );
};
export default RewardsSummarySection;
